/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { getAppName, getAppVersion } from '../lib/app'
import { HTMLAttributes } from 'react'

function AppVersion (props: HTMLAttributes<HTMLElement>) {
  return (
    <small {...props}>{`${getAppName()} v${getAppVersion()}`}</small>
  )
}

export default AppVersion
